import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ChiSiamo from './pages/ChiSiamo';
import Offerte from './pages/Offerte';
import Contattaci from './pages/Contattaci';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import CookiePolicy from './pages/legal/CookiePolicy';
import TermsAndConditions from './pages/legal/TermsAndConditions';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Helmet>
            <title>Rinova Group - Consulenza Gratuita Offerte Luce, Gas e Internet</title>
            <meta name="description" content="Rinova Group - Servizio gratuito di consulenza e comparazione offerte per luce, gas e internet. Confronta le migliori tariffe senza obbligo di sottoscrizione." />
            <meta name="keywords" content="rinova group, confronto offerte luce, confronto offerte gas, offerte internet, consulenza energetica gratuita, comparazione tariffe, risparmio bollette" />
            <link rel="canonical" href="https://rinovagroup.it" />
          </Helmet>
          <ScrollToTop />
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={
                <>
                  <Helmet>
                    <title>Rinova Group - Consulenza Gratuita Offerte Luce, Gas e Internet</title>
                    <meta name="description" content="Servizio gratuito di consulenza e comparazione delle offerte per luce, gas e internet. Confronta le tariffe e scegli liberamente, senza obblighi." />
                    <link rel="canonical" href="https://rinovagroup.it" />
                  </Helmet>
                  <Home />
                </>
              } />
              <Route path="/chi-siamo" element={
                <>
                  <Helmet>
                    <title>Chi Siamo | Rinova Group - Consulenza Energetica Indipendente</title>
                    <meta name="description" content="Rinova Group: da oltre 10 anni offriamo consulenza gratuita e indipendente per il confronto delle offerte luce, gas e internet. Nessun obbligo." />
                    <link rel="canonical" href="https://rinovagroup.it/chi-siamo" />
                  </Helmet>
                  <ChiSiamo />
                </>
              } />
              <Route path="/offerte" element={
                <>
                  <Helmet>
                    <title>Confronta Offerte Luce, Gas e Internet | Rinova Group</title>
                    <meta name="description" content="Confronta le offerte disponibili per luce, gas e internet. Consulenza gratuita e senza obbligo di sottoscrizione. La scelta è sempre tua." />
                    <link rel="canonical" href="https://rinovagroup.it/offerte" />
                  </Helmet>
                  <Offerte />
                </>
              } />
              <Route path="/contattaci" element={
                <>
                  <Helmet>
                    <title>Contattaci per una Consulenza Gratuita | Rinova Group</title>
                    <meta name="description" content="Richiedi una consulenza gratuita e senza impegno. Il nostro team ti aiuterà a confrontare le offerte disponibili per luce, gas e internet." />
                    <link rel="canonical" href="https://rinovagroup.it/contattaci" />
                  </Helmet>
                  <Contattaci />
                </>
              } />
              
              <Route path="/privacy-policy" element={
                <>
                  <Helmet>
                    <title>Informativa sulla Privacy | Rinova Group</title>
                    <meta name="description" content="Informativa sulla privacy ai sensi del GDPR (Reg. UE 2016/679). Scopri come Rinova Srl raccoglie, utilizza e protegge i tuoi dati personali." />
                    <link rel="canonical" href="https://rinovagroup.it/privacy-policy" />
                  </Helmet>
                  <PrivacyPolicy />
                </>
              } />
              <Route path="/cookie-policy" element={
                <>
                  <Helmet>
                    <title>Cookie Policy | Rinova Group</title>
                    <meta name="description" content="Cookie Policy ai sensi del D.Lgs. 196/2003. Informazioni sui cookie utilizzati su rinovagroup.it e su come gestirli." />
                    <link rel="canonical" href="https://rinovagroup.it/cookie-policy" />
                  </Helmet>
                  <CookiePolicy />
                </>
              } />
              <Route path="/termini-e-condizioni" element={
                <>
                  <Helmet>
                    <title>Termini e Condizioni | Rinova Group</title>
                    <meta name="description" content="Termini e condizioni di utilizzo del sito rinovagroup.it e del servizio gratuito di consulenza energetica di Rinova Srl." />
                    <link rel="canonical" href="https://rinovagroup.it/termini-e-condizioni" />
                  </Helmet>
                  <TermsAndConditions />
                </>
              } />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;
